import React, { memo } from 'react';
import { CalendarCheckIcon } from '../../assets/icons/CalendarCheckIcon';
import { ChevronArrowLeftIcon } from '../../assets/icons/ChevronArrowLeftIcon';
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon';
import {
  CalendarLanguage,
  ptbrCalendarLanguage,
  ptbrInlineMonthPickerLabelGenerator,
} from '../../utils/CalendarUtils';
import IconButton from '../iconButton/IconButton';
import './InlineMonthPicker.scss';
const rootClassName = 'inline-month-picker';

export interface InlineMonthPickerProps {
  value: Date;
  onChange?: (d: Date) => void;
  disabled?: boolean;
  language: CalendarLanguage;
  labelGen?: (d: Date) => string;
}

function InlineMonthPicker(props: InlineMonthPickerProps) {
  const d = new Date(props.value.getTime());

  const fix31st = (months: number) => {
    const m = d.getMonth() + (months || 1);
    d.setMonth(m);

    if (d.getMonth() !== m % 12) {
      d.setDate(0);
    }
  };

  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-icon`}>
        <CalendarCheckIcon />
      </div>
      <div className={`${rootClassName}-label`}>
        {props.labelGen?.(props.value)}
      </div>
      <div className={`${rootClassName}-actions`}>
        <IconButton
          icon={<ChevronArrowLeftIcon />}
          onClick={() => {
            d.setMonth(d.getMonth() - 1);
            props.onChange?.(d);
          }}
          disabled={props.disabled}
        />
        <IconButton
          icon={<ChevronArrowRightIcon />}
          onClick={() => {
            fix31st(1);
            props.onChange?.(d);
          }}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
}

InlineMonthPicker.defaultProps = {
  value: new Date(),
  language: ptbrCalendarLanguage,
  labelGen: ptbrInlineMonthPickerLabelGenerator,
} as InlineMonthPickerProps;

export default memo(InlineMonthPicker);
